import { change } from 'redux-form';

import { CREATE_EDIT_TRUCK_ROUTE_FORM_NAME } from 'Common/FormEnum';
import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { CreateEditTruckRouteEnum } from 'Common/FieldEnum';

import * as types from './types';

export const getSiteItemsBySiteIds = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_SITE_ITEMS_BY_SITE_IDS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TruckRoute/GetSiteItemsBySiteIds',
        payload
      );
      const data = response.data.Data;
      if (data.Message) {
        dispatch(success(types.SET_SITE_ITEMS_MESSAGE, data.Message));
        payload.SiteIds.length && payload.SiteIds.pop();
        dispatch(
          change(
            CREATE_EDIT_TRUCK_ROUTE_FORM_NAME,
            CreateEditTruckRouteEnum.SiteIds,
            payload.SiteIds
          )
        );
      } else {
        dispatch(
          success(types.GET_SITE_ITEMS_BY_SITE_IDS, data.ItemSiteDetails)
        );
      }
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching items for sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.GET_SITE_ITEMS_BY_SITE_IDS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.GET_SITE_ITEMS_BY_SITE_IDS_LOADING, false));
    }
  };
};

export const saveTruckRoute = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SAVE_TRUCK_ROUTE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TruckRoute/WriteTruckRoute',
        payload
      );
      dispatch(success(types.SAVE_TRUCK_ROUTE, response.data.Data));
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while saving truck route. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.SAVE_TRUCK_ROUTE_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SAVE_TRUCK_ROUTE_LOADING, false));
    }
  };
};

export const setSelectedSite = site => {
  return {
    type: types.SET_SELECTED_SITES,
    payload: site,
  };
};
export const clearErrors = () => {
  return {
    type: types.CLEAR_ERRORS,
  };
};
export const clearSavedMessage = () => {
  return {
    type: types.CLEAR_SAVE_TRUCK_ROUTE,
  };
};
export const clearSiteItems = () => {
  return {
    type: types.CLEAR_SITE_ITEMS,
  };
};

export const getTruckRouteById = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SELECTED_TRUCK_ROUTE_DETAIL_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TruckRoute/GetTruckRouteById/${id}`
      );
      dispatch(success(types.SELECTED_TRUCK_ROUTE_DETAIL, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route detail. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SELECTED_TRUCK_ROUTE_DETAIL_LOADING_ERROR,
          defaultError
        )
      );
    }
    dispatch(loading(types.SELECTED_TRUCK_ROUTE_DETAIL_LOADING, false));
  };
};

export const emptySelectedItem = () => {
  return change(
    CREATE_EDIT_TRUCK_ROUTE_FORM_NAME,
    CreateEditTruckRouteEnum.ItemIds,
    []
  );
};
export const clearSiteItemsMessage = () => {
  return {
    type: types.CLEAR_SITE_ITEMS_MESSAGE,
  };
};

export const getItemsByDistributorIds = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_ITEMS_BY_VENDOR_IDS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TruckRoute/GetItemsByDistributorIds',
        payload
      );
      const data = response.data.Data;
      if (data.Message) {
        dispatch(success(types.SET_SITE_ITEMS_MESSAGE, data.Message));
        payload.DistributorIds.length && payload.DistributorIds.pop();
        dispatch(
          change(
            CREATE_EDIT_TRUCK_ROUTE_FORM_NAME,
            CreateEditTruckRouteEnum.VendorIds,
            payload.DistributorIds
          )
        );
      } else {
        dispatch(success(types.GET_ITEMS_BY_VENDOR_IDS, data.ItemSiteDetails));
      }
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching items for distributors. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.GET_ITEMS_BY_VENDOR_IDS_LOADING_ERRORS,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.GET_ITEMS_BY_VENDOR_IDS_LOADING, false));
    }
  };
};

export const getTruckRouteAssignmentTypes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING, true));
      const response = await MPWWebApi.getGeneric(
        'TruckRoute/GetTruckRouteAssignmentTypes'
      );
      dispatch(
        success(types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route assignment types. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING, false));
    }
  };
};
export const getTruckRouteTypes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.GET_TRUCK_ROUTE_TYPES_LOADING, true));
      const response = await MPWWebApi.getGeneric(
        'TruckRoute/GetTruckRouteTypes'
      );
      dispatch(success(types.GET_TRUCK_ROUTE_TYPES, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route types. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_TRUCK_ROUTE_TYPES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.GET_TRUCK_ROUTE_TYPES_LOADING, false));
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckroute/actions.js